import React from 'react';
import BaseCreatePage from '../../_CustomComponents/BaseCreatePage';
import { connect } from "react-redux";
import PortletSpinner from '../../../../partials/layout/PortletSpinner';
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";
import { Alert } from "react-bootstrap";
import * as projectOrderCrud from '../../../../crud/projectOrder.crud';
import * as projectsCrud from '../../../../crud/projects.crud';
import * as instructionToQuoteCrud from '../../../../crud/instructionToQuote.crud';
import * as itqQuotationCrud from '../../../../crud/itqQuotation.crud';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import moment from 'moment';
import { FormattedMessage } from "react-intl";
import { withCreatePageProps } from '../../../../shared/hoc/withCreatePageProps';
import Common from '../../../../shared/common';
import { actionCodes } from "../../../../shared/lookup";

class ProjectCreatePage extends BaseCreatePage {
    constructor(props) {
        super(props);
        const { subject } = ((props.location.state || {}).itemCustomProps || {});
        const { state } = props.location;
        this.createDefaultSubject = subject;
        this.createDefaultFields = state;

        this.state = {
            showAlert: true,
            formFields: null
        };
    }

    fetchRelatedQuotation = async (instructiontoquoteid) => {
        try {
            const { data: relatedAcceptedQuote } = await itqQuotationCrud.getAcceptedQuotation(instructiontoquoteid);
            return relatedAcceptedQuote;
        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            return null
        }
    }
    setFormFields = async () => {
        const { fields } = this.props.workflowItem;
        let relatedQuotation = null;
        let defaultItqSelection = null;
        if (fields.ItqRelation.visible && this.createDefaultFields?.itemBaseProps?.reftype === 'Itq' && this.createDefaultFields?.itemBaseProps?.refid) {
            //create page, redirected from create related button
            relatedQuotation = await this.fetchRelatedQuotation(this.createDefaultFields?.itemBaseProps?.refid);
            //AUTO-SELECT RFQ DROPDOWN (IF REDIRECTED FROM CREATE-RELATED BUTTON)
            defaultItqSelection = Number(this.createDefaultFields.itemBaseProps.refid);
            console.log("defaultItqSelection", defaultItqSelection);
        }

        const formFields = {
            currencyCode: this.props.contract.currency,
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: [
                { resource: 'GENERAL.FORMS.FIELD.SUBJECT', dataField: 'subject', editorOptions: { defaultValue: relatedQuotation?.subject } },
                { note: this.props.resources.Note }
            ]
        };
        if (fields.ProjectRelation.visible) {
            formFields.fields.push({ label: fields.ProjectRelation.label, dataField: 'linkedprojectid', required: fields.ProjectRelation.required, editorType: 'dxSelectBox', editorOptions: { dataSource: this.getProjectOptions(), valueExpr: 'projectid', displayExpr: 'display' } });
        }
        if (fields.ProjectOrderNumber.visible) {
            formFields.fields.push({ label: fields.ProjectOrderNumber.label, dataField: 'projectordernumber', required: fields.ProjectOrderNumber.required });
        }
        if (fields.PurchaseOrderValue.visible) {
            formFields.fields.push({ label: fields.PurchaseOrderValue.label, dataField: 'purchaseordervalue', required: fields.PurchaseOrderValue.required, editorType: 'dxNumberBox' });
        }

        if (fields.ItqRelation.visible) {
            formFields.fields.push({ label: fields.ItqRelation.label, dataField: 'instructiontoquoteid', required: fields.ItqRelation.required, editorType: 'dxSelectBox', editorOptions: { dataSource: this.getITQsDataSourceOptions(), valueExpr: 'value', displayExpr: 'display', defaultValue: defaultItqSelection } });
        }

        if (fields.Description.visible) {
            formFields.fields.push({ label: fields.Description.label, dataField: 'description', editorType: 'dxHtmlEditor', editorOptions: { defaultValue: relatedQuotation?.description } })
        }
        if (fields.Comments.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultCommentsValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.comments;
            formFields.fields.push({ label: fields.Comments.label, dataField: 'comments', editorType: 'dxHtmlEditor', editorOptions: { defaultValue: defaultCommentsValue } })
        }
        if (fields.ItemsList.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultItemsListValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.itemslist;
            formFields.fields.push({ label: fields.ItemsList.label, dataField: 'pricelistdescription', editorOptions: { defaultValue: defaultItemsListValue } })
        }
        if (fields.TotalListPrice.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultTotalListPriceValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.totallistprice;
            formFields.fields.push({ label: fields.TotalListPrice.label, dataField: 'pricelisttotal', editorType: 'dxNumberBox', editorOptions: { defaultValue: defaultTotalListPriceValue } })
        }
        if (fields.CompensationDescription.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultCompensationDescriptionValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.instructiontoquotedescription;
            formFields.fields.push({ label: fields.CompensationDescription.label, dataField: 'compensationeventdescripton', editorOptions: { defaultValue: defaultCompensationDescriptionValue } })
        }
        if (fields.TotalAssessed.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultTotalAssessedValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.totalassessed;
            formFields.fields.push({ label: fields.TotalAssessed.label, dataField: 'compensationeventtotal', editorType: 'dxNumberBox', editorOptions: { defaultValue: defaultTotalAssessedValue } })
        }
        if (fields.TotalPrice.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultTotalPriceValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.totalprice;
            formFields.fields.push({ label: fields.TotalPrice.label, dataField: 'projectordertotal', editorType: 'dxNumberBox', value: this.calculateTotal, editorOptions: { defaultValue: defaultTotalPriceValue } })
        }
        if (fields.StartDate.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultStartDateValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.startdate;
            formFields.fields.push({ label: fields.StartDate.label, dataField: 'startdate', editorType: 'dxDateBox', editorOptions: { defaultValue: defaultStartDateValue } });
        }
        if (fields.CompletionDate.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultCompletionDateValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.completiondate;
            const completionDateField = { label: fields.CompletionDate.label, dataField: 'completiondate', editorType: 'dxDateBox', editorOptions: { defaultValue: defaultCompletionDateValue }, validation: { type: 'range', min: new Date(1900, 0, 1), max: new Date(2079, 5, 6), warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" }) } }
            if (fields.StartDate.visible) {
                completionDateField.validation = { type: 'custom', validationCallback: (obj, value) => (obj.startdate <= value), warning: 'Completion date can not be earlier than start date' }
            }
            formFields.fields.push(completionDateField);
        }
        if (fields.DelayAmount.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultDelayAmountValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.delayamount;
            formFields.fields.push({ label: fields.DelayAmount.label, dataField: 'delaydamagestotal', editorType: 'dxNumberBox', editorOptions: { defaultValue: defaultDelayAmountValue } })
        }
        if (fields.DelayPaymentPeriod.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultDelayPaymentPeriodValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.delaypaymentperiod;
            formFields.fields.push({ label: fields.DelayPaymentPeriod.label, dataField: 'delaydamagestype', editorType: 'dxSelectBox', editorOptions: { dataSource: this.props.paymentPeriods, defaultValue: defaultDelayPaymentPeriodValue } })
        }
        if (fields.BonusRate.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultBonusRateValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.bonusrate;
            formFields.fields.push({ label: fields.BonusRate.label, dataField: 'bonusrate', editorOptions: { defaultValue: defaultBonusRateValue } });
        }
        if (fields.BonusCalculationPeriod.visible) {
            //DO NOT USE DEFAULT IF STATUS IS 3- PM TO MAKE ASSESSMENT
            let defaultBonusCalculationPeriodValue = relatedQuotation?.status === 3 ? null : relatedQuotation?.bonuscalculationperiod;
            formFields.fields.push({ label: fields.BonusCalculationPeriod.label, dataField: 'bonuscalculationperiod', editorType: 'dxSelectBox', editorOptions: { dataSource: this.props.calculationPeriods, defaultValue: defaultBonusCalculationPeriodValue } });
        }

        this.setState({ formFields });

    }
    calculateTotal = (obj) => {
        const prc1 = obj.pricelisttotal ? obj.pricelisttotal : 0;
        const prc2 = obj.compensationeventtotal ? obj.compensationeventtotal : 0;
        return prc1 + prc2;
    }

    getITQsDataSourceOptions = () => {
        const { companyid, projectid, contractid } = this.props.contract;
        const toStates = ['APMA', 'ARQ', 'APMRQ', 'AQ', 'QA', 'APMR'];
        const datasource = {
            loadMode: 'raw',
            cacheRawData: true,
            load: () => {
                var promise = new Promise(async (resolve) => {
                    const { data: responseObj } = await instructionToQuoteCrud.getContractInstructionToQuotes(companyid, projectid, contractid, '');
                    let ITQs = JSON.parse(responseObj.aggregatelist);
                    ITQs = ITQs.filter(ntf => {
                        if (toStates.includes(ntf.status)) {
                            return true;
                        }
                        else return false;
                    }).map(itm => {
                        return {
                            value: itm.instructiontoquoteid,
                            reference: itm.referenceid,
                            title: itm.subject,
                            display: `${itm.referenceid}   {${itm.subject}}`
                        }
                    });
                    resolve(ITQs);
                });
                return promise;
            }
        }
        return datasource;
    }
    getProjectOptions = () => {
        const { companyid } = this.props.contract;
        const datasource = {
            loadMode: 'raw',
            cacheRawData: true,
            load: () => {
                var promise = new Promise((resolve, reject) => {
                    projectsCrud.getCutDownProjectsList(companyid)
                        .then(response => {
                            let projectList = [];
                            if (response.data && response.data.length > 0) {
                                projectList = response.data.map(project => ({ projectid: project.projectid, display: (project.projectcode ? `[${project.projectcode}] - ` : "") + `${project.name}` }));
                            }
                            else {
                                this.props.enqueueSnackbar('No project found for selected the company', { variant: 'warning', });
                            }
                            resolve(projectList);
                        })
                        .catch(err => {
                            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                            reject(err);
                        });
                });
                return promise;
            }
        }
        return datasource;
    }
    submitHandler = (project) => {
        project.companyid = this.props.contract.companyid;
        project.contractid = this.props.contract.contractid;
        project.projectid = this.props.contract.projectid;
        if (project.startdate) {
            project.startdatedisplay = moment(project.startdate).format('DD/MM/YYYY');
        }
        if (project.completiondate) {
            project.completiondatedisplay = moment(project.completiondate).format('DD/MM/YYYY');
        }

        project.status = 'Not Communicated';
        project.actioncode = actionCodes.CREATE;
        project.workflowid = this.props.workflowItem.id;
        this.appendRelationship(project);
        Common.PropertyConversionsBeforeNoticeSaveRequest(project, this.props.customFields, this.props.contractUsers);
        projectOrderCrud.createProjectOrder(project)
            .then(response => {
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.DRAFT_SUCCESS' }), { variant: 'success', });
                try {
                    const createdID = Number(response.data);
                    this.props.navigate(this.props.workflowItem.paths.basePath + createdID);
                }
                catch {
                    this.props.navigate(this.props.workflowItem.paths.listPath);
                }
            })
            .catch(err => {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', key: "PersistentFormWarning", persist: true });
            });
    }

    componentDidMount() {
        this.setFormFields();
    }

    render() {
        if (!this.state.formFields) {
            return (<PortletSpinner />);
        }

        const { assetid } = ((this.props.location.state || {}).itemCustomProps || {});
        const { fields } = this.props.workflowItem;



        return (
            <Portlet>
                <PortletHeader title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.CREATE_TITLE' }, { ITEM_NAME: this.props.workflowItem.pageTitle })} />
                <PortletBody style={{ maxWidth: 1000 }}>
                    {this.state.showAlert && (
                        <Alert variant="secondary" onClose={() => this.setState({ showAlert: false })} dismissible>
                            <p>
                                <FormattedMessage id="GENERAL.FORMS.WARNING_DRAFT" />
                            </p>
                        </Alert>
                    )}
                    {this.props.resources.WarningBanner && (
                        <Alert variant="warning" >
                            <p>
                                {this.props.resources.WarningBanner}
                            </p>
                        </Alert>
                    )}
                    <BiDynamicForm
                        onSubmitHandler={this.submitHandler}
                        config={this.state.formFields}
                        customFields={(this.props.customFields || {}).COMMUNICATION}
                        valueChangeHandler={this.fieldChanged}
                        assetFieldsEnabled={this.props.workflowItem.assetFieldsEnabled}
                        assetid={assetid}
                    />

                </PortletBody>
            </Portlet>
        );
    }
}

const mapStateToProps = store => ({
    contractUsers: store.contract.users
});

export default withCreatePageProps(connect(mapStateToProps)(ProjectCreatePage));
